import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a7e22444")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_table = _resolveComponent("c-table")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    width: "1000px",
    "before-close": _ctx.onCancel
  }, {
    default: _withId(() => [
      _createVNode(_component_c_table, {
        class: "mt20",
        dataSource: _ctx.tableConfig,
        onPageCurrentChange: _ctx.pageCurrentChange,
        onPageSizeChange: _ctx.pageSizeChange
      }, null, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})